// extracted by mini-css-extract-plugin
module.exports = {"container":"e_mr","title":"e_nr","titleIcon":"e_or","summary":"e_pr","sourcesTitle":"e_qr","sources":"e_rr","source":"e_sr"};